var trans = {
    "general": {
        "nav_zip_codes": "Zip Codes",
        "nav_zip_code": "Zip Code",
        "nav_cp4_verification": "Verify cp4",
        "nav_div_admin": "Administrative Areas",
        "nav_counties": "Counties",
        "nav_simulators": "Simulators",
        "nav_districts": "Districts",
        "nav_hypermarkets": "Hypermarkets",
        "nav_fregs": "Parishes",
        "nav_demo_data": "Demographic Data",
        "nav_fire_departments": "Fire Departments",
        "nav_police_stations": "Police Stations",
        "nav_services": "Services",
        "home": "Home",
        "nav_net_salary": "Net salary",
        "nav_sources": "Sources",
        'nav_env_expenses': 'Enviroment expenses per inhabitant',
        'nav_birth_rate': 'Birth Rate',
        "general": "General",
        "informations": "Informations",
        "censuses": 'Censuses',
        "page_not_found": 'The page you are looking for was not found.',
        "administrator": "Administrator"
    },
    "Home": {
        "home": "Home"
    },
    "Admin_Counties": {
        "resident_population": "Resident population",
        "population_density": "Population density",
        "iso_code": "ISO code",
        "iso_code_3": "3 letters code",
        "area": "Area",
        "county": "County",
        "search_county": "Search county",
        "map_style": "Map style",
        "meteorology": "meteorology",
        "know_more": "Know More"
    },
    "Admin_Districts": {
        "district": "District",
        "resident_population": "Resident population",
        "population_density": "Population density",
        "iso_code": "ISO code",
        "area": "Area",
        "search_district": "Search district",
        "map_style": "Map style",
        "meteorology": "meteorology",
        "know_more": "Know More"
    },
    "Admin_Fregs": {
        "resident_population": "Resident population",
        "population_density": "Population density",
        "iso_code": "ISO code",
        "area": "Area",
        "county": "County",
        "map_style": "Map style",
        "meteorology": "meteorology",
        "parish": "Parish",
    },
    "Demo_Counties": {
        "graphic": "Graphic",
        "inhabitants_per_year": "Inhabitants per year",
        "map_style": "Map style",
        "population_density": "Population density",
        "resident_population": "Resident population",
        "county": "County",
        "search_county": "Search county",
        "table": "Table",
        "yearly_evolution": 'Yearly Evolution'
    },
    "Demo_Districts": {
        "graphic": "Graphic",
        "district": "District",
        "population_density": "Population density",
        "map_style": "Map style",
        "resident_population": "Resident population",
        "search_district": "Search district",
        "inhabitants_per_year": "Inhabitants per year",
        "table": "Table",
        "yearly_evolution": 'Yearly Evolution'
    },
    "Demo_Fregs": {
        "graphic": "Graphic",
        "county": "County",
        "resident_population": "Resident population",
        "disclaimer": 'When these censuses were carried out, the <a href="{assets_url}docs/agragacao_fregs_2013.pdf" target="_blank">aggregation of parishes</a> had not yet been implemented, so it is not possible to provide other more complete data about current parishes and their demographics.'
    },
    "Zip_Codes": {
        "map": "map",
        "county": "County",
        "map_style": "Map style",
        "zip_code": "Zip code",
        "select_result_box": "Click on one of the items on the left box",
        "address": "Address",
        "street_avenue": "Street\/Avenue",
        "local_county": "Locality\/County",
        "results": "results",
        "district": "District",
        "cod_arteria": "Street code",
        "cod_localidade": "Locality code",
        "tipo_arteria": "Street type",
        "titulo_arteria": "Street title",
        "primeira_preposicao": "First preposition",
        "segunda_preposicao": "Second preposition",
        "designacao_arteria": "Street designation",
        "descricao_troco": "Section description",
        "info_art\u00e9ria": "Street info",
        "nome_cliente": "Client name",
        "designacao_postal": "Postal designation",
        "nome_localidade": "Locality name",
        "cp4_verification": "Verify CP4",
        "zip_code_404": 'Zip Code not found',
        "cp4_404": 'CP4 not found',
    },
    "Fire_Departments": {
        "map": "map",
        "map_style": "Map style",
        "no_results": "Couldn't find any results for this county",
        "select_result_box": "Click on one of the items on the left box",
        "search_county": "Search county",
        "all_counties": "All counties",
        "county": "County",
        "district": "District",
        "address": "Address",
        "phone": "Phone",
        "details": "Details"
    },
    "Police_Stations": {
        "map": "map",
        "map_style": "Map style",
        "no_results": "Couldn't find any results for this county",
        "select_result_box": "Click on one of the items on the left box",
        "search_county": "Search county",
        "all_counties": "All counties",
        "county": "County",
        "district": "District",
        "name": "Name",
        "phone": "Phone",
        "address": "Address"
    },
    "Hypermarkets": {
        "map": "map",
        "map_style": "Map style",
        "no_results": "Couldn't find any results for this county",
        "select_result_box": "Click on one of the items on the left box",
        "search_county": "Search county",
        "all_counties": "All counties",
        "county": "County",
        "phone": "Phone",
        "manager": "Manager",
        "name": "Name",
        "district": "District",
        "schedule": "Schedule",
        "address": "Address"
    },
    "Net_Salary": {
        "dependents": "Dependents",
        "year": "Year",
        "others_renu_suj": "Other Compensations subject to taxes",
        "others_renu_not_suj": "Other Compensations not subject to taxes",
        "sector": "Sector",
        "5_or_more": "5 or more",
        "invalid_val": "Invalid value, must be numeric",
        "choose_one": "Choose one of the options",
        "subsidies": "Subsidies",
        "sub_alimentation": "Alimentation Subsidie",
        "val_sub_alimentation": "Alimentation Subsidie Value",
        "paid_days": "Number of Paid Says",
        "seg_social": "Social Security",
        "situation": "Situation",
        "region": "Region",
        "continent": "Continente",
        "private": "Private",
        "public": "Public",
        "base_salary": "Base Salary",
        "sub_ali_total": "Total Alimentation Subsidy",
        "val_suj_seg_irs": "Subject Value subject to IRS and Social Sec.",
        "sub_ali_suj_seg_irs": "Alimentation Subsidy subject to IRS and Social Sec.",
        "total_brute": "Total Brute",
        "tax_irs": "IRS Rate",
        "tax_social_seg": "Social Sec. Rate",
        "tax_adse": "ADSE Rate",
        "retencao_irs_total": "Total Taxes IRS",
        "seg_social_total": "Total Social Sec.",
        "total_taxes": "Imposto Total",
        "net_salary": "Net Salary",
        "total_net_salary": "Total Salary"
    },
    'Enviroment_Expenses': {
        'comp_title': 'Enviroment expenses per inhabitant',
        "year": "Year",
        'district': 'District'
    },
    'Birth_Rate': {
        'comp_title': 'Birth Rate',
        "year": "Year",
        "graphic": "Graphic",
        "table": "Table",
        'district': 'District'
    },
    "404_not_found": {
        "page_not_found": 'The page you are looking for was not found.'
    }
}

export default trans;